import { HazardType, HazardView, SelectedHazardViewType } from '@/features';

const popupDefaults = [HazardType.TotalFireBans, HazardType.Incident, HazardType.FireDangerRating, HazardType.PrescribedBurns];

export const hazardTypeView = (activeView: HazardView, hazardType: HazardType) => {
  if (activeView === HazardView.List) return SelectedHazardViewType.Modal;

  return popupDefaults.includes(hazardType) ? SelectedHazardViewType.Popup : SelectedHazardViewType.Modal;
};
